@let _item = navItem();
@if (layout() === 'list') {
  <a
    class="nav-row"
    [matButton]="rla.isActive ? 'tonal' : ''"
    [routerLink]="_item.route"
    [queryParams]="_item.queryParams"
    routerLinkActive
    #rla="routerLinkActive"
  >
    <mat-icon aria-hidden="true">{{ _item.icon }}</mat-icon>
    <span class="nav-row-label mat-body-medium" [class.bold]="rla.isActive">{{ _item.label }}</span>
    @if (_item.badge) {
      <span class="nav-row-badge mat-label-small">{{ _item.badge }}</span>
    }
  </a>
} @else {
  <!-- Nur Icons (sehr niedriges Fenster, Layout `responsive`): das Label faellt weg, der Name steht
       als Tooltip und fuer Screenreader am Link. -->
  <div class="nav-button" [routerLink]="_item.route" tabindex="-1">
    <a
      [matButton]="rlaRail.isActive ? 'tonal' : ''"
      [routerLink]="_item.route"
      [queryParams]="_item.queryParams"
      routerLinkActive
      #rlaRail="routerLinkActive"
      libClickStopPropagation
      [matTooltip]="_item.label"
      matTooltipPosition="right"
      [matTooltipDisabled]="!nurIcons()"
      [attr.aria-label]="nurIcons() ? _item.label : null"
    >
      <span>
        <mat-icon [matBadge]="_item.badge === 0 ? undefined : _item.badge" aria-hidden="false">{{ _item.icon }}</mat-icon>
      </span>
    </a>
    @if (!nurIcons()) {
      <p
        class="mat-label-medium"
        [ngClass]="{
          bold: rlaRail.isActive,
        }"
      >
        {{ _item.label }}
      </p>
    }
  </div>
}
